import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this a physical product or a digital download?',
  a: 'This is a 100% digital product delivered in high-quality PDF format. You can access it from your computer, tablet, smartphone, or iPad immediately after purchase.'
}, {
  q: 'Is it suitable for newly qualified physical therapists?',
  a: 'Yes. The system is designed for both newly qualified professionals and experienced physical therapists who want to save time and organize their clinical workflow.'
}, {
  q: 'Can I use it in private practice and rehabilitation clinics?',
  a: 'Absolutely. The templates, planning systems, documentation, and patient resources can be used in private clinics, rehabilitation centers, sports medicine practices, and hospital settings.'
}, {
  q: 'Does it cover different rehabilitation conditions?',
  a: 'Yes. The system includes assessment tools, rehabilitation frameworks, treatment planning resources, exercise libraries, patient education materials, and documentation templates covering a wide range of common musculoskeletal conditions.'
}, {
  q: 'How quickly will I notice the benefits?',
  a: 'Most physical therapists report saving hours of planning and documentation during their very first week of using the system.'
}, {
  q: 'Do I need special software to use these templates?',
  a: 'No. The resources are provided in standard, universally accessible formats (PDFs and editable documents) that do not require any expensive or specialized software to open or use.'
}, {
  q: 'Are the home exercise programs customizable?',
  a: "Yes. The Home Exercise Builder™ bonus includes editable templates so you can tailor the exercises, sets, reps, and instructions to each individual patient's needs."
}, {
  q: 'Is this a monthly subscription?',
  a: 'No. It is a one-time payment of $27 USD. You get lifetime access to the complete 6-in-1 system and all 5 premium bonuses with no recurring fees.'
}, {
  q: 'Can I share these resources with my clinic staff?',
  a: "Yes. Your purchase grants you a license to use these resources within your immediate clinical practice and share them with your direct support staff to standardize your clinic's workflow."
}, {
  q: 'What if I am not satisfied with the system?',
  a: 'You are protected by our 7-Day Money-Back Guarantee. If you are not completely satisfied, simply email us within 7 days of purchase for a full, no-questions-asked refund.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 px-4 sm:px-6 bg-white" data-id="element-40" data-mp="2ulqanj8do696">
      <div className="text-center mb-12" data-id="element-41" data-mp="2ukyg8bqioekh">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-42" data-mp="1n86d1eejhhp7">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-4 max-w-3xl mx-auto" data-id="element-43" data-mp="1j8ntalygfcny">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-paper border border-gray-200 rounded-xl overflow-hidden shadow-sm transition-colors hover:border-brand-navy/30" data-id="element-44" data-mp="3uvr8tovmdrbj" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center gap-4 focus:outline-none" aria-expanded={openIndex === i} data-id="element-45" data-mp="7nvzg9xmyn3y">
              <span className="font-bold text-brand-navy text-sm sm:text-base leading-tight" data-id="element-46" data-mp="mdbnhi5s8efy">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-5 h-5 text-brand-navy transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-47" data-mp="qghp2chy9hg3" />
            </button>

            {openIndex === i && <div className="px-6 pb-6 text-brand-ink/80 text-sm leading-relaxed border-t border-gray-200 pt-5" data-id="element-48" data-mp="2x5wb3gxs9ekz">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}